// extracted by mini-css-extract-plugin
export var container = "styles-module__container___dcbbv";
export var icon = "styles-module__icon___SI4hr";
export var shareDrawer = "styles-module__shareDrawer___aoC_X";
export var shareImageContainer = "styles-module__shareImageContainer___fkV5O";
export var successImage = "styles-module__successImage___e4G0E";
export var title = "styles-module__title___Rz2BF";